import { useState } from 'react'
import { v4 } from 'uuid'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Alert,
  Stack,
} from '@mui/material'
import { Form, Switch, TextField } from '@ui/forms'
import ResultsValidityWarning from './components/ResultsValidityWarning'

interface Props {
  open: boolean
  onClose: () => void
  onConfirm: (name: string, asPdf: boolean) => void
  unusedTemplates: boolean
}

const DocumentNameModal = ({ open, onClose, onConfirm, unusedTemplates }: Props) => {
  const [id, setId] = useState<string>('document-name-form')

  const handleClose = () => {
    onClose()
  }

  return (
    <Dialog open={open} onClose={handleClose}>
      <Form
        key={id}
        onSubmit={data => {
          onConfirm(data.name, data.asPdf)
          setId(v4())
          handleClose()
        }}
        defaultValues={{ name: 'Statikdokument', asPdf: false }}
      >
        <DialogTitle>Dokument erzeugen</DialogTitle>
        <DialogContent style={{ minWidth: 400 }}>
          <Stack direction="column" spacing={1}>
            <ResultsValidityWarning />
            {unusedTemplates && (
              <Alert severity="warning">
                Es werden noch nicht alle Templates für das Statikdokument verwendet (oder sind
                nicht verlinkt)
              </Alert>
            )}
            <TextField name="name" placeholder="Dokumentname" label="Name" />
            <Switch name="asPdf" label="Auch als PDF erzeugen" size="small" />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Schließen</Button>
          <Button type="submit" variant="contained">
            OK
          </Button>
        </DialogActions>
      </Form>
    </Dialog>
  )
}

export default DocumentNameModal
